// Webpack Imports
import * as bootstrap from 'bootstrap';
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	$('.navbar-nav ul.dropdown-menu .dropdown-toggle').on('click', function(event) {
		event.preventDefault();
		event.stopPropagation();

		$(this).parent().siblings().removeClass('open');
		$(this).parent().toggleClass('open');
	});


	function delay(fn, ms) {
		let timer = 0
		return function(...args) {
			clearTimeout(timer)
			timer = setTimeout(fn.bind(this, ...args), ms || 0)
		}
	}
	
	// var GetSearch = document.getElementById('searchform-custom')
	// $(document).on('keyup', '#searchform-custom', function() {
	$(document).on('keyup', '#searchform-custom', delay(function (e) {
		liveSearch();
	}, 500));

	$(document).on('change', '.filter-input-search', delay(function (e) {
		liveSearch();
	}, 500));

	function liveSearch() {
		if($('#searchform-custom').data('live')) {
			if($('#searchform-custom').val().length >= 3) {

				var loaderIcon = $('.search-results-container').removeClass('hide-loader');
				var searchQuery = $('#searchform-custom').val();
				var selectedFilters = []; // initialize array

				$('.search-form .form-checkbox-list input[type=checkbox]').each(function() {
					if ($(this).is(":checked")) {
						selectedFilters.push(
							{
								'post_type': $(this).attr('name'),
								'value': 1
							}
						);
					}
				});
	
				let url = '/wp-json/rinnai/v1/search_preview';

				window.axios.get(
					url, 
					{
						params: {
							...Object.fromEntries( selectedFilters.map((t) => [t.post_type, t.value]) ),
							s: searchQuery
						}
					}
				)
				.then(response => {
					$('.search-results__response').html(response.data.results);

				})
				.finally(() => {
					loaderIcon.addClass('hide-loader');
				})
				.catch(error => {
					console.log('error');
					console.log(error)
				})
			}
		}
	}
} )();

jQuery(window).on('elementor/frontend/init', function() {
    var hash = window.location.hash;
    var savedURL = sessionStorage.getItem('savedURL');

    // Only proceed with the logic if there is a hash in the URL
    if (hash) {
        var targetTabLink = document.querySelector('a[data-tab-id="' + hash.substring(1) + '"]');
        var targetTabContent = document.getElementById(hash.substring(1));
        
        if (targetTabLink && targetTabContent) {
            // Remove active class from all tabs and tab contents
            document.querySelectorAll('#tab-list .nav-item.active, .tab-pane.active').forEach(function (element) {
                element.classList.remove('active');
            });

            // Activate the tab and content
            targetTabLink.classList.add('active');
            targetTabContent.classList.add('active');

            const rangeTab = new bootstrap.Collapse( targetTabContent.querySelector('.collapse') )
            rangeTab.show()

            // Store the current URL with the hash in sessionStorage
            sessionStorage.setItem('savedURL', window.location.href);
        }
    } else {
		// Set first tab and content as active on load
		$('.dynamic-tabs-widget .nav-tabs li:first-child a').addClass('active');
		$('.dynamic-tabs-widget .tab-content .tab-pane:first-child').addClass('active');
	}
});

// SOF Downloads Page JS

jQuery(document).ready(function($) {
	let openedFromSearch = false;

	function loadDropdown(level, parentId) {
		$.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			data: {
				action: 'load_marketing_page_children',
				parent_id: parentId
			},
			success: function(response) {
				var placeholders = {
					1: "Select Need",
					2: "Select Category",
					3: "Select Range",
					4: "Select Product"
				};

				let placeholder_length = Object.entries(placeholders).length;
				$('#select-level-' + level).prop('disabled', false);

				// set the placeholders for every child beneath the current selected
				for(let i = level; i <= placeholder_length; i++) {
					$('#select-level-' + i).html('<option value="">' + placeholders[i] + '</option>' + response);
					// Disable any siblings that shouldn't be able to be selected until the one right before it has been
					if(level < i) {
						$('#select-level-' + i).prop('disabled', true);
					}
				}
			}
		});
	}

	function resetSelectFields() {
		$('#select-level-1, #select-level-2, #select-level-3, #select-level-4').each(function() {
			$(this).val(''); // Reset each dropdown to the default (empty) option
		});
	}

	$('#select-level-1, #select-level-2, #select-level-3').on('change', function() {
		var selectedId = $(this).val();
		var nextLevel = parseInt(this.id.replace('select-level-', '')) + 1;

		if (selectedId) {
			loadDropdown(nextLevel, selectedId); // Load and populate the next dropdown
			
			// Enable the next dropdown by removing the disabled attribute
			// $('#select-level-' + nextLevel).prop('disabled', false);
		} else {
			// If no option is selected, disable the subsequent dropdowns
			$('#select-level-' + nextLevel + ', #select-level-3, #select-level-4').prop('disabled', true);
		}
	
		$('#product-result').empty();
	});

	$('#select-level-4.downloads').on('change', function() {
		var selectedId = $(this).val();
		var productName = $('#select-level-4 option:selected').text(); // Get the selected product name
	
		if (selectedId) {
			$('#search-result').hide();
			
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'get_marketing_page_data',
					post_id: selectedId
				},
				success: function(response) {
					// Create the heading dynamically with the product name
					var heading = '<h5 class="my-2 text-start">Downloads for "' + productName + '"</h5>';
					
					// Add the heading and the response content to #product-result
					$('#product-result').html(heading + response).show();
	
					// Smooth scroll to the #product-result container
					$('html, body').animate({
						scrollTop: $('#product-result').offset().top
					}, 500);
				},
				error: function(xhr, status, error) {
					console.log('Error:', error);
				}
			});
		}
	});

	$('#select-level-4.warranty').on('change', function() {
		var selectedId = $(this).val();
		var productName = $('#select-level-4 option:selected').text(); // Get the selected product name
	
		if (selectedId) {
			$('#product-result').hide();
			
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'get_marketing_page_data_warranty',
					post_id: selectedId
				},
				success: function(response) {
					// Create the heading dynamically with the product name
					var heading = '<h5 class="my-2 text-start">Search results for "' + productName + '"</h5>';
					
					// Add the heading and the response content to #product-result
					$('#search-result').html(heading + response).show();
	
					// Smooth scroll to the #product-result container
					$('html, body').animate({
						scrollTop: $('#search-result').offset().top
					}, 500);
				},
				error: function(xhr, status, error) {
					console.log('Error:', error);
				}
			});
		}
	});


	$('#search-button.downloads').on('click', function () {
		var query = $('#product-search').val();
	
		if (query.length > 2) {
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'search_marketing_pages',
					query: query
				},
				success: function (response) {
					// Check if the response already includes a heading
					// if (!response.includes('<h5>')) {
					// 	// Add the dynamic search term heading only if not present
					// 	var searchHeading = '<h5>Search results for "' + query + '"</h5>';
					// 	response = searchHeading + response;
					// }
	
					// Display the results
					$('#search-result').html(response).show();
	
					// Hide product details if visible
					$('#product-result').hide();
	
					// Scroll to the search results container after results load
					$('html, body').animate({
						scrollTop: $('#search-result').offset().top
					}, 500);
				},
				error: function (xhr, status, error) {
					$('#search-result').html('<p>An error occurred. Please try again.</p>');
					console.log('Error:', error);
				}
			});
		} else {
			$('#search-result').html('<p>Please enter at least 3 characters to search.</p>');
		}
	});

	$('#search-button.warranty').on('click', function() {
		var query = $('#product-search').val();
	
		if (query.length > 2) {
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'search_marketing_pages_warranty',
					query: query
				},
				success: function(response) {
					// Add the dynamic search term heading
					var searchHeading = '<h5>Search results for "' + query + '"</h5>';
					$('#search-result').html(searchHeading + response).show();
	
					// Hide product details if visible
					$('#product-result').hide();
	
					// Scroll to the search results container after results load
					$('html, body').animate({
						scrollTop: $('#search-result').offset().top
					}, 500);
				},
				error: function(xhr, status, error) {
					$('#search-result').html('<p>An error occurred. Please try again.</p>');
					console.log('Error:', error);
				}
			});
		} else {
			$('#search-result').html('<p>Please enter at least 3 characters to search.</p>');
		}
	});
	
	// $('#tradesmart-product-search-form').on('submit', function(e) {
	$('body').on('submit', '#tradesmart-product-search-form', function(e) {
		e.preventDefault();

		performProductSearch();
	});

	$(document).on('click', '.search-results .pagination-button', function () {
	// $(document).on('click', '.pagination-prev, .pagination-next', function () {
        const page = $(this).data('page');
        performProductSearch(page);
    });

	function performProductSearch(page = 1) {
		const query = $('#product-search').val();

		if (query.length > 2) {
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'tradesmart_search_products',
					query: query,
					page: page
				},
				success: function(response) {

					$('#product-search-container > .e-con-inner').html(response);
	
					// // Scroll to the search results container after results load
					$('html, body').animate({
						scrollTop: $('#product-search-container').offset().top
					}, 500);
				},
				error: function(xhr, status, error) {
					$('#search-result').html('<p>An error occurred. Please try again.</p>');
					console.log('Error:', error);
				}
			});
		} else {
			$('#search-result').html('<p>Please enter at least 3 characters to search.</p>');
		}
	}

	$('#blogFilterOptions').on('change', function () {
        var url = $(this).val();
        if (url) {
            window.location = url;
        }
        return false;
    });

	// Event handler for search result item clicks
	$(document).on('click', '.search-result-item', function(event) {
		event.preventDefault(); // Prevent the default anchor behavior

		// Retrieve the post ID from the data attribute
		var postId = $(this).data('product-key');

		// Verify that we have a valid postId before making the AJAX request
		if (postId) {
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				data: {
					action: 'get_marketing_page_data',
					post_id: postId,
					from_search: true
				},
				success: function(response) {
					// Load the response into #product-result and display it
					$('#product-result').html(response).show();
					
					// Hide the search result container
					$('#search-result').hide();

					// Smooth scroll to the #product-result container
					$('html, body').animate({
						scrollTop: $('#product-result').offset().top
					}, 500);
				},
				error: function(xhr, status, error) {
					$('#product-result').html('<p>An error occurred while loading the product details. Please try again.</p>');
					console.log('Error:', error);
				}
			});
		}
	});

	// Handle active state for the filter list
	$('.faq-filter-list a').on('click', function (e) {
		// Remove active class from all links
		$('.faq-filter-list a').removeClass('active');
		
		// Add active class to the clicked link
		$(this).addClass('active');
	});

	// Handle active state for the dropdown
	$('.faq-filter-dropdown').on('change', function () {
		const selectedValue = $(this).val();

		// Update the active state in the filter list
		$('.faq-filter-list a').each(function () {
			if ($(this).attr('href') === selectedValue) {
				$(this).addClass('active');
			} else {
				$(this).removeClass('active');
			}
		});

		// Smooth scroll to the selected section
		const target = $(selectedValue);
		if (target.length) {
			$('html, body').animate(
				{
					scrollTop: target.offset().top,
				},
				600 // Animation duration in milliseconds
			);
		}
	});
	

	loadDropdown(1, 0);

	let addressField = document.querySelector('.gfield--type-address .address_line_1 input');

	if (addressField) {
		// Initialize the autocomplete widget.
		let autocomplete = new google.maps.places.Autocomplete(addressField, {
			types: ['geocode'],
			componentRestrictions: { country: "NZ" },
		});

		// Immediately override the autocomplete attribute.
		addressField.setAttribute('autocomplete', 'rin-address');

		// In case the Google Maps script reassigns the attribute,
		// use a MutationObserver to enforce your desired value.
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === 'autocomplete' && addressField.getAttribute('autocomplete') !== 'rin-address') {
					addressField.setAttribute('autocomplete', 'rin-address');
				}
			});
		});
		observer.observe(addressField, { attributes: true });

		let latField = document.querySelector('.gfield input.latitude');
		let lngField = document.querySelector('.gfield input.longitude');
		let suburbField = document.querySelector('.gfield--type-address .address_line_2 input');
		let cityField = document.querySelector('.gfield--type-address .ginput_address_city input');
		let postcodeField = document.querySelector('.gfield--type-address .ginput_address_zip input');

		autocomplete.addListener('place_changed', function() {
			let place = autocomplete.getPlace();

			if (place.geometry) {
				if (latField) {
					latField.value = place.geometry.location.lat();
				}
				if (lngField) {
					lngField.value = place.geometry.location.lng();
				}
			}

			if (!place.address_components) return;

			let streetNumber = "";
			let streetName = "";
			let suburb = "";
			let city = "";
			let postcode = "";

			place.address_components.forEach((component) => {
				let type = component.types[0];

				if (type === "street_number") {
					streetNumber = component.long_name;
				}
				if (type === "route") {
					streetName = component.long_name;
				}
				if (type === "locality") {
					city = component.long_name; // e.g., Auckland
				}
				if (type === "postal_code") {
					postcode = component.long_name; // e.g., 0800
				}
				if (type === "sublocality_level_1" || type === "administrative_area_level_3") {
					suburb = component.long_name; // e.g., Kumeu
				}
			});

			// Populate the form fields.
			addressField.value = `${streetNumber} ${streetName}`;
			suburbField.value = suburb;
			cityField.value = city;
			postcodeField.value = postcode;
		});
	}
});

// EOF Downloads Page JS

// SOF Product Gallery JS

// jQuery(document).ready(function($) {
//     // Initialize Bootstrap Carousel
//     $('#galleryCarousel').carousel();

//     // Manually trigger slide change on arrow clicks
//     $('.carousel-control-prev').on('click', function(event) {
//         event.preventDefault();
//         $('#galleryCarousel').carousel('prev'); // Move to the previous slide
//     });

//     $('.carousel-control-next').on('click', function(event) {
//         event.preventDefault();
//         $('#galleryCarousel').carousel('next'); // Move to the next slide
//     });

//     // Thumbnail click event to change carousel slide
//     $('.carousel-thumbnails img').on('click', function() {
//         var index = $(this).data('slide-to');
        
//         // Change to the selected slide
//         $('#galleryCarousel').carousel(index);

//         // Update active thumbnail
//         $('.carousel-thumbnails img').removeClass('active');
//         $(this).addClass('active');
//     });

//     // Update active thumbnail when carousel slides via arrows or autoplay
//     $('#galleryCarousel').on('slid.bs.carousel', function(e) {
//         var index = $(e.relatedTarget).index();

//         // Set the corresponding thumbnail as active
//         $('.carousel-thumbnails img').removeClass('active');
//         $('.carousel-thumbnails img').eq(index).addClass('active');
//     });
// });


jQuery(document).ready(function($) {
    var currentIndex = 0; // Track the current image index for the lightbox

    // Initialize Bootstrap Carousel
    $('#galleryCarousel').carousel();

    // Manually trigger slide change on arrow clicks in the main carousel
    $('.carousel-control-prev').on('click', function(event) {
        event.preventDefault();
        $('#galleryCarousel').carousel('prev');
    });

    $('.carousel-control-next').on('click', function(event) {
        event.preventDefault();
        $('#galleryCarousel').carousel('next');
    });

    // Thumbnail click event to change carousel slide
    $('.carousel-thumbnails img').on('click', function() {
        var index = $(this).data('slide-to');
        
        // Change to the selected slide
        $('#galleryCarousel').carousel(index);

        // Update active thumbnail
        $('.carousel-thumbnails img').removeClass('active');
        $(this).addClass('active');
    });

    // Update active thumbnail when carousel slides via arrows or autoplay
    $('#galleryCarousel').on('slid.bs.carousel', function(e) {
        var index = $(e.relatedTarget).index();

        // Set the corresponding thumbnail as active
        $('.carousel-thumbnails img').removeClass('active');
        $('.carousel-thumbnails img').eq(index).addClass('active');
    });

    // Open lightbox modal when the main carousel image is clicked (only on desktop)
    $('#galleryCarousel .carousel-item img').on('click', function() {
        // Check if the screen width is above the mobile threshold (e.g., 768px)
        if ($(window).width() >= 768) {
            // Get the current active image's index in the carousel
            currentIndex = $(this).closest('.carousel-item').index();

            // Set the source of the lightbox image to the current image
            var imgSrc = $(this).attr('src');
            $('#lightboxImage').attr('src', imgSrc);

            // Open the modal
            $('#lightboxModal').modal('show');
        }
    });

    // Lightbox Next and Previous Controls for navigation within the modal
    $('.lightbox-control-next').on('click', function(event) {
        event.preventDefault();
        currentIndex = (currentIndex + 1) % $('#galleryCarousel .carousel-item').length; // Increment index and wrap around
        updateLightboxImage();
    });

    $('.lightbox-control-prev').on('click', function(event) {
        event.preventDefault();
        currentIndex = (currentIndex - 1 + $('#galleryCarousel .carousel-item').length) % $('#galleryCarousel .carousel-item').length; // Decrement index and wrap around
        updateLightboxImage();
    });

    // Function to update the lightbox image based on currentIndex
    function updateLightboxImage() {
        var newImageSrc = $('#galleryCarousel .carousel-item').eq(currentIndex).find('img').attr('src');
        $('#lightboxImage').attr('src', newImageSrc);
    }
});


jQuery(document).ready(function($) {
    // Handle dropdown change event
    $(document).on('change', '#cadBimVariants', function() {
        var selectedVariant = $(this).val(); // Get the selected value
        console.log('Selected Variant:', selectedVariant); // Debugging

        // Hide all variant content
        $('.variant-secion-content').hide();

        // Show the content matching the selected variant
        if (selectedVariant) {
            $('.variant-secion-content[data-variant-id="' + selectedVariant + '"]').show();
        }
    });

    // Hide all content by default
    $('.variant-secion-content').hide();
});

// EOF Product Gallery

